/** Aides d'affichage des statistiques de favoris (période Europe/Paris, valeurs inconnues). */

export const MAX_DAYS = 62;

const parisFormatter = new Intl.DateTimeFormat('fr-CA', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
});

/** AAAA-MM-JJ du jour, à Paris. */
export const parisToday = (date = new Date()) => parisFormatter.format(date);

export const shiftDay = (iso, days) =>
  new Date(Date.parse(`${iso}T12:00:00Z`) + days * 86_400_000).toISOString().slice(0, 10);

export const PERIODS = [
  { value: 'today', label: "Aujourd'hui" },
  { value: '7d', label: '7 derniers jours' },
  { value: '30d', label: '30 derniers jours' },
  { value: 'custom', label: 'Période personnalisée' },
];

/** Période demandée au serveur ; null si invalide (le serveur plafonne à 62 jours). */
export function resolvePeriod(value, today, custom = {}) {
  if (value === 'today') return { start_date: today, end_date: today };
  if (value === '7d') return { start_date: shiftDay(today, -6), end_date: today };
  if (value === '30d') return { start_date: shiftDay(today, -29), end_date: today };
  const { start, end } = custom;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(start || '') || !/^\d{4}-\d{2}-\d{2}$/.test(end || '')) return null;
  if (start > end) return null;
  const days = (Date.parse(`${end}T12:00:00Z`) - Date.parse(`${start}T12:00:00Z`)) / 86_400_000 + 1;
  return days > MAX_DAYS ? null : { start_date: start, end_date: end };
}

/** null / undefined = inconnu (affiché « — »), 0 = vrai zéro. */
export const formatCount = (value) =>
  value === null || value === undefined ? '—' : new Intl.NumberFormat('fr-FR').format(value);

export const formatFrDate = (iso) => (iso ? iso.split('-').reverse().join('/') : null);

export function productLabel(row) {
  if (row.product_name) return row.product_name;
  return row.product_status === 'absent_du_catalogue' ? 'Produit absent du catalogue' : row.product_id;
}

/** État d'affichage : chargement / erreur / aucune donnée / données. */
export function viewState({ loading, error, stats }) {
  if (loading) return 'loading';
  if (error) return 'error';
  if (!stats) return 'error';
  const empty = !stats.current || stats.current.accounts_ever_synced === 0;
  return empty && !stats.events ? 'empty' : 'data';
}
